import { Button as MUIButton } from "@mui/material";
import Backbutton from "assets/backbutton";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { handleBack, handleNext } from "./CustomPlanCreation.slice";

import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import React from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { getPlanDetailsRoute } from "utils/StoreUtils";
import ActionCardDialogsContext from "../ActionCard/Context";

const CustomPlanCreationFooter = (props: any) => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const navigate = useNavigate();

  const { formRef } = props;

  const flow: any = useAppSelector((state) => state.CustomPlanCreation.flow);
  const { currentStep, totalSteps } = useAppSelector((state) => state.CustomPlanCreation);
  const myPlanDetails = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const { setIsOpenCustomPlanCreateDialog } = React.useContext(ActionCardDialogsContext);

  const planId = myPlanDetails.id;

  const handleNextClick = async () => {
    switch (flow[currentStep]) {
      case `${translate("custom.plan.creation.step1")}`:
        const { success } = planId ? await formRef?.current?.submitEditForm() : await formRef?.current?.submitForm();
        if (success) {
          dispatch(handleNext());
        }
        break;

      default:
        dispatch(handleNext());
    }
  };

  const onSubmit = async () => {
    switch (flow[currentStep]) {
      case `${translate("custom.plan.creation.step1")}`:
        const response = planId ? await formRef?.current?.submitEditForm() : await formRef?.current?.submitForm();
        if (response.success) {
          setIsOpenCustomPlanCreateDialog(false);
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              variant: "success",
              setState: setFeedbackDetails({ shouldShow: false }),
              message: messages.planAdded
            })
          );
          navigate(`/${getPlanDetailsRoute()}/${response.apiRes?.id || planId}`);
        }
        break;

      default:
        setIsOpenCustomPlanCreateDialog(false);
        dispatch(
          setFeedbackDetails({
            shouldShow: true,
            variant: "success",
            setState: setFeedbackDetails({ shouldShow: false }),
            message: messages.planAdded
          })
        );
        navigate(`/${getPlanDetailsRoute()}/${planId}`);
    }
  };

  const cancelHandler = () => {
    setIsOpenCustomPlanCreateDialog(false);
  };

  return (
    <>
      <div>
        {currentStep !== 0 ? (
          <MUIButton
            sx={{ paddingLeft: "0px", gap: "8px", marginY: { xs: "0", md: "unset" } }}
            variant="text"
            onClick={() => dispatch(handleBack())}
            disabled={currentStep === 0}
          >
            <Backbutton color={tokens.Text.General.Color}></Backbutton>
            <Typography color={tokens.Text.General.Color} children="Back" variant="body1" />
          </MUIButton>
        ) : (
          <>{!planId && <Button variant="secondary" label="Cancel" onClick={cancelHandler} />}</>
        )}
      </div>
      <div>
        <div className="left-action-item">
          <Button variant="secondary" label="Submit" onClick={onSubmit} />
          {currentStep !== totalSteps && <Button label={"Next"} onClick={handleNextClick} />}
        </div>
      </div>
    </>
  );
};

export default CustomPlanCreationFooter;
